module.exports = __webpack_public_path__ + "static/media/feeling_nothing.ce6057d5.svg";